<template>
  <v-menu
    v-model="showMenu"
    :disabled="isCurrentNodeArchived"
    eager
  >
    <template v-slot:activator="{props }">
      <v-btn
        v-bind="props"
        :disabled="isCurrentNodeArchived"
        color="primary"
        elevation=0
        class="ml-2"
        data-cy="nodeSideMenu-createNodes-button"
        density="comfortable"
        :aria-label="$t('menus.tools.createNode')"
      >
        <v-icon style="">mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-list data-cy="nodeSideMenu-createNodes-menu">
        <v-list-item v-if="showingCreateFolder" @click="showCreateFolderDialgo()" data-cy="nodeSideMenu-createNodes-createFolder">
          <v-list-item-title>
            <v-icon size="small" start>mdi-folder-plus</v-icon>
            {{ $t('menus.createNode.createFolder') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="showingCreateProject" @click="showCreateProjectDialog()" data-cy="nodeSideMenu-createNodes-createProject">
          <v-list-item-title>
            <v-icon size="small" start>mdi-briefcase-plus</v-icon>
            {{ $t('menus.createNode.createProject') }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="showingCreateClient" @click="showCreateClientDialog()" data-cy="nodeSideMenu-createNodes-createClient">
          <v-list-item-title>
            <v-icon size="small" start>tw tw-office-building-plus</v-icon>
            {{ $t('menus.createNode.createClient') }}
          </v-list-item-title>
        </v-list-item>
    </v-list>
  </v-menu>

  <CreateNodeDialog
    v-if="showingCreateFolder"
    v-model="showingCreateFolderDialog"
    :nodeType="nodeTypes.FOLDER"
    :parentNode="currentNode"
  />

  <CreateNodeDialog
    v-if="showingCreateProject"
    v-model="showingCreateProjectDialog"
    :nodeType="nodeTypes.PROJECT"
    :parentNode="currentNode"
  />

  <CreateNodeDialog
    v-if="showingCreateClient"
    v-model="showingCreateClientDialog"
    :nodeType="nodeTypes.CLIENT"
    :parentNode="currentNode"
  />
</template>

<script>
import { useNodeStore } from '@/stores/NodeStore.js'
import { useCommonStore } from '@/stores/CommonStore.js'
import CreateNodeDialog from './dialogs/CreateNodeDialog.vue'

export default {
  name: "CreateNodesMenu",
  components: {
    CreateNodeDialog,
  },
  data() {
    return {
      // dialog: false,
      showMenu: false,

      showingCreateFolderDialog: false,
      showingCreateProjectDialog: false,
      showingCreateClientDialog: false,
    };
  },

  methods: {
    stub() {
      this.showMenu = false;
    },
    showCreateFolderDialgo() {
      this.showingCreateFolderDialog = true;
    },
    showCreateProjectDialog() {
      this.showingCreateProjectDialog = true;
    },
    showCreateClientDialog() {
      this.showingCreateClientDialog = true;
    }
  },
  computed: {
    currentNode() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    isCurrentNodeArchived() {
      return Boolean(this.currentNode && this.currentNode.archived);
    },
    nodeTypes() {
      const commonStore = useCommonStore();
      return commonStore.nodeTypes;
    },
    showingCreateFolder() {
      return true;
    },
    showingCreateProject() {
      // return  this.currentNode &&
      //         (this.currentNode.type == this.nodeTypes.CLIENT ||
      //         this.currentNode.type == this.nodeTypes.TENANT);

      return true;
    },
    showingCreateClient() {
      return true;
    },
  }
}
</script>

<style>
</style>
